import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from "@chakra-ui/react";
import { FunctionComponent } from "react";

import { CreateOrEditUserForm } from "./CreateOrEditUserForm";
import { User } from "../../../api";
interface Props {
    show: boolean;
    onClose: () => void;
    clientUserData?: User;
    existingClientUsers?: User[];
}

export const CreateOrEditUserModal: FunctionComponent<Props> = ({ show, onClose, clientUserData, existingClientUsers }: Props) => {
    const isEdit = Boolean(clientUserData?.azureAdObjectId);

    return (
        <Modal isOpen={show} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{isEdit ? "Edit System Admin Status" : "Add User"}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <CreateOrEditUserForm onClose={onClose} userData={clientUserData} existingUsers={existingClientUsers} isEdit={isEdit} />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
